export interface ILessonCardActivity {
  readonly title: string
  readonly hasAssessment: boolean
}